module.exports = __webpack_public_path__ + "static/img/product2.ab588ae2.png";